export const BUSINESS_UNITS_TABLE_LABELS = {
	VIEW_DETAILS: 'View Details'
} as const;
